import { NgModule } from "@angular/core";
import { CustomersListComponent } from './customers-list/customers-list.component';
import { CustomersService } from "./shared/customers.service";
import { CustomersRoutingModule } from "./customers-routing.module";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { CustomersAddComponent } from './customers-add/customers-add.component';
import { MapModule } from "../map/map.module";
import { SharedModule } from "../../shared/shared.module";
import { ApiRoutes } from "../../shared/api-routes";

@NgModule({
  declarations: [
    CustomersListComponent,
    CustomersAddComponent
  ],
  imports: [
    CustomersRoutingModule,
    TranslateModule,
    SharedModule,
    MapModule
  ],
  providers: [ApiRoutes, CustomersService],
  exports: [
    CustomersListComponent
  ]
})
export class CustomersModule {
  constructor(public translate: TranslateService) {
  }
}
